"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Loader = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var Icon_1 = require("./Icon");
var pro_duotone_svg_icons_1 = require("@fortawesome/pro-duotone-svg-icons");
var OVERLAY_CLASS = "absolute flex inset-0 bg-lochivar-default bg-opacity-25 z-10";
var INDICATOR_CLASS = "m-auto py-1 px-3 bg-white bg-opacity-75 text-lochivar-default shadow rounded-full";
var SPIN_CLASS = "animate-spin m-auto p-0";
var Loader = function () {
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: OVERLAY_CLASS }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: INDICATOR_CLASS }, { children: (0, jsx_runtime_1.jsx)("p", __assign({ className: SPIN_CLASS, style: { fontSize: "2rem" } }, { children: (0, jsx_runtime_1.jsx)(Icon_1.Icon, { icon: pro_duotone_svg_icons_1.faSpinnerThird, mode: "default" }, void 0) }), void 0) }), void 0) }), void 0));
};
exports.Loader = Loader;
